import { InjectionToken } from '@angular/core';
import { CacheManagerStore } from 'cache-manager';

export const ServerCache = new InjectionToken<CacheManagerStore>('diskCache');
